/** 判断 Resource URI 是否显式使用未加密 HTTP。 */
export function isInsecureHttpResourceUri(value: string): boolean {
  try {
    return new URL(value.trim()).protocol === 'http:'
  } catch {
    return false
  }
}
